enum ReportType {
  ALL_DASHBOARDS = "allDashboards",
  UPGRADE_YOUR_REPORTS = "upgradeYourReports",
  PINNED_DASHBOARD = "pinnedDashboard",
  OVERVIEW = "overview",
  ACTIVITY = "activity",
  DEALS = "deals",
  EMAIL_ACTIVITY = "emailActivity",
  MILEAGE_TRACKING = "mileageTracking",
  PERMISSIONS_REPORT = "permissionsReport",
  DEALS_BY_GEOGRAPHY = "dealsByGeography",
  EXPORTS = "exports",
  EXPORT_EDIT = "exportEdit",
  REVENUE = "revenue",
  SCORE_CARD = "scorecard",
  COMPANIES = "companies",
  PEOPLE = "people",
  ROUTES = "routes",
  LEADERBOARD = "stackRank",
}

export default ReportType;
